import { useState } from "react";
import { useAuth } from "@/context/AuthContext";
import { api, formatApiError } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { MailWarning } from "lucide-react";
import { toast } from "sonner";

export default function VerifyBanner() {
  const { user, refresh } = useAuth();
  const [sending, setSending] = useState(false);
  if (!user || user.verified || user.role === "admin") return null;

  const resend = async () => {
    setSending(true);
    try {
      await api.post("/auth/resend-verification");
      toast.success(`Verification email sent to ${user.email}`);
      refresh();
    } catch (e) {
      toast.error(formatApiError(e.response?.data?.detail) || "Could not send");
    } finally {
      setSending(false);
    }
  };

  return (
    <div
      className="w-full bg-amber-500/10 border-b border-amber-500/30 text-amber-200 text-sm py-2.5 px-6 flex items-center justify-between gap-4"
      data-testid="verify-banner"
    >
      <div className="flex items-center gap-2">
        <MailWarning className="w-4 h-4 text-amber-400" />
        <span>
          Please confirm your email <span className="font-medium text-amber-100">{user.email}</span> to start generating leads.
        </span>
      </div>
      <Button
        size="sm"
        variant="outline"
        onClick={resend}
        disabled={sending}
        className="rounded-full border-amber-500/40 text-amber-200 hover:bg-amber-500/15"
        data-testid="verify-resend-btn"
      >
        {sending ? "Sending…" : "Resend email"}
      </Button>
    </div>
  );
}
